// Optional order-date period for the status counts. Without one the backend counts the last 30 days,
// which is also the most it ever counts.
const periodParams = (period) =>
  (period?.startDate ? `&startDate=${encodeURIComponent(period.startDate)}` : "") +
  (period?.endDate ? `&endDate=${encodeURIComponent(period.endDate)}` : "");

export const ROUTES_NAME = {
  profile: "/dashboard/profile",
  table:"/stores/advanced-search",
  paypalSetting:"/paypal/settings",
  pullLogs:"/pull-logs",
  report: "/reports/performances",
  carrier:"/carriers",
  events:"/stores/events",
  find_detail:"/stores/find-detail",
  stats:"/stores/stats",
  processes:"/stores/processes",
  processes_queue:"/stores/processes/queue",
  shop_countries: `/stores/list-country`,
  all_countries: (storeType)=> `/store/routing-policy/all-countries?storeType=${storeType}`,
  networth:(shopId,storeType)=>`/store/dashboard/networth?shopId=${shopId}&storeType=${storeType}`,
  synced : (shopId, storeType, period) => `/store/dashboard/synced?shopId=${shopId}&storeType=${storeType}${periodParams(period)}`,
  synced_last_ten_days: (shopId,storeType) => `/store/dashboard/synced-last-10days?shopId=${shopId}&storeType=${storeType}`,
  received_last_ten_days :(shopId,storeType) => `/store/dashboard/received-last-10days?shopId=${shopId}&storeType=${storeType}`,
  linked_paypal_by_shop: (shopId,storeType) => `/store/dashboard/linked-paypal-by-shop?shopId=${shopId}&storeType=${storeType}`,
  dashboard_all:(shopId, storeType, period) => `/store/dashboard/all?shopId=${shopId}&storeType=${storeType}${periodParams(period)}`,
  failed:(shopId, storeType, period) => `/store/dashboard/failed?shopId=${shopId}&storeType=${storeType}${periodParams(period)}`,
  missing : (shopId, storeType, period) => `/store/dashboard/missing?shopId=${shopId}&storeType=${storeType}${periodParams(period)}`,
  queued:(shopId, storeType, period) => `/store/dashboard/queued?shopId=${shopId}&storeType=${storeType}${periodParams(period)}`,
  pending: (shopId, storeType, period) => `/store/dashboard/pending?shopId=${shopId}&storeType=${storeType}${periodParams(period)}`,
  invalid_gateway: (shopId, storeType, period) => `/store/dashboard/invalid-gateway?shopId=${shopId}&storeType=${storeType}${periodParams(period)}`,
  advanceSearch : (shopId,storeType) => `/store/order/advanced-search?shopId=${shopId}&storeType=${storeType}`,
  resync: (shopId,storeType) => `/store/order/re-sync-orders?shopId=${shopId}&storeType=${storeType}`,
  historicalStatus : (shopId,storeType) => `/store/historical/status?shopId=${shopId}&storeType=${storeType}`,
  storeQueue : (id,storeType ) => `/store/historical/queue?shopId=${id}&storeType=${storeType}`,
  storeAllCarrier : (shopId,storeType) => `/store/routing-policy/all-carriers?shopId=${shopId}&storeType=${storeType}`,
  storeAllGeoCarrier : (shopId,storeType) => `/store/routing-policy/list-carriers-by-geo?shopId=${shopId}&storeType=${storeType}`,
  deleteCarrier : (shopId,storeType) => `/store/routing-policy/delete-paypal-carrier?shopId=${shopId}&storeType=${storeType}`,
  addCarrier : (shopId,storeType) => `/store/routing-policy/add-paypal-carrier?shopId=${shopId}&storeType=${storeType}`,
  historicalCount : (shopId,storeType) => `/store/historical/count?shopId=${shopId}&storeType=${storeType}`,
  paypal_setting_default : (payload) => `/store/paypal-settings/default?payPalSettingId=${payload}`,
  paypal_setting_delete : (payload) => `/store/paypal-settings/delete?payPalSettingId=${payload}`,
  digital_sync : (shopId,storeType) => `/store/setting/digital-sync?shopId=${shopId}&storeType=${storeType}`,
  courier_mapping : (shopId,storeType) => `/store/setting/courrier-mapping?shopId=${shopId}&storeType=${storeType}`,
  find_by_id : (shopId,storeType) => `/store/setting/find-by-id?shopId=${shopId}&storeType=${storeType}`,
  fullfillment :() => `/checker/fulfillment`,
  paypalChecker : ()=> `/checker/paypal`,
  paypalTxLookup : ()=> `/paypal/tx/lookup`,
  paypalTxExport : (shopId, merchantId, days) => `/paypal/tx/export?shopId=${shopId}&shopMerchantAccountId=${encodeURIComponent(merchantId)}&days=${days}`,
  fetch_by_name: "/checker/fetch-by-name",
  possible_orders: (shopId,storeType) => `/store/historical/order-count?shopId=${shopId}&storeType=${storeType}`,
  cancelDigitalOrder: (id, storeType) => `/reindex/cancel-digital?shopId=${id}&storeType=${storeType}`,
  cacheSync : (id, storeType) => `/cache/sync?shopId=${id}&storeType=${storeType}`,
  troubleshoot_totalOrders: (id,storeType) => `/stores/totalOrders?shopId=${id}&storeType=${storeType}`,
  troubleshoot_awaitingSync: (id, storeType) => `/stores/awaitingSync?shopId=${id}&storeType=${storeType}`,
  troubleshoot_totalSynced: (id, storeType) => `/stores/totalSynced?shopId=${id}&storeType=${storeType}`,
  gdpr: (gdprActionType, storeType, page, pageSize ) => `/gdpr?gdprActionType=${gdprActionType}&storeType=${storeType}&page=${page}&pageSize=${pageSize}`,
  orderGenerator: () => `/order/generator/generate-orders`,
  usage: (shopId) => `/store/setting/usage-stats?shopId=${shopId}`,
  chargesList: (shopId, storeType, first, afterCursor) => {
    const params = new URLSearchParams({ shopId, first });
    if (storeType) params.set("storeType", storeType);
    if (afterCursor) params.set("afterCursor", afterCursor);
    return `/store/charges/list?${params.toString()}`;
  },
};
